import RangeSummary from "./components/views/RangeSummary";
import DashboardView from "./components/views/DashboardView";
import CauseAnalysisView from "./components/views/CauseAnalysisView";
import SimpleAnalyticsView from "./components/views/SimpleAnalyticsView";
import VersusView from "./components/views/VersusView";
import FeederScoreView from "./components/views/FeederScoreView";
import ComparisonView from "./components/views/ComparisonView";
import SettingsDrawer from "./components/views/SettingsDrawer";
import CalendarDialog from "./components/views/CalendarDialog";
import React from 'react';
import scappLogo from '../../../../Components/utils/logo_scapp_blanco.png';
export default function PanelTemplate(v) {
  return React.createElement('div', {
    className: 'scapp-full'
  }, v.text("\n\n"), React.createElement("div", {
    style: {
      "width": "100%",
      "height": "100%",
      "overflow": "hidden",
      "background": "rgb(3,8,18)",
      "position": "relative"
    }
  }, v.text("\n"), React.createElement("div", {
    style: {
      "position": "absolute",
      "left": v.offX / 19.2 + "vw",
      "top": v.offY / 10.8 + "vh",
      "width": v.cW / 19.2 + "vw",
      "height": v.cH / 10.8 + "vh",
      "transform": "scale(" + v.scale + ")",
      "transformOrigin": "0 0",
      "display": "flex",
      "flexDirection": "column",
      "gap": "0",
      "padding": "0",
      "background": "radial-gradient(100% 100% at 50% 0%, rgba(46,179,238,0.08) 0%, rgba(0,0,0,0) 70%), linear-gradient(180deg, rgb(10,20,35) 0%, rgb(3,8,18) 100%)"
    }
  }, v.text("\n  "), React.createElement("header", {
    style: {
      "height": "8vh",
      "width": "100%",
      "flex": "none",
      "display": "flex",
      "alignItems": "center",
      "justifyContent": "space-between",
      "padding": "0.5vh 1vw",
      "background": "transparent",
      "borderBottom": "0.1vh solid #e84e0e",
      "boxShadow": "none",
      "fontFamily": "'Bai Jamjuree','Segoe UI','Tahoma',sans-serif"
    }
  }, v.text("\n    "), React.createElement("div", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.9vw",
      "flex": "0 0 16%",
      "minWidth": "0"
    }
  }, v.text("\n      "), v.itgSlot, v.text("\n      "), v.languageSlot, v.text("\n    ")), v.text("\n    "), React.createElement("div", {
    style: {
      "display": "flex",
      "flexDirection": "column",
      "alignItems": "center",
      "justifyContent": "center",
      "gap": "0",
      "flex": "1 1 auto",
      "minWidth": "0",
      "padding": "0 2.2vw",
      "height": "7vh"
    }
  }, v.text("\n      "), v.vsHdr ? React.createElement(React.Fragment, null, React.createElement("button", {
    "onClick": v.openVsSel,
    "title": "Cambiar selección",
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0",
      "background": "rgba(3,10,22,0.7)",
      "border": "0.01vw solid rgba(46,179,238,0.18)",
      "borderRadius": "0.5vw",
      "padding": "0.4vh 0.75vw",
      "cursor": "pointer",
      "fontFamily": "'IBM Plex Sans',sans-serif"
    }
  }, (v.vsChips || []).map((c, index0) => React.createElement(React.Fragment, {
    key: index0
  }, React.createElement("span", {
    style: {
      "display": "flex",
      "alignItems": "center"
    }
  }, c.vs ? React.createElement(React.Fragment, null, React.createElement("span", {
    style: {
      "margin": "0 0.52vw",
      "padding": "0.1vh 0.47vw",
      "background": "oklch(0.66 0.19 42)",
      "color": "#fff",
      "font": "italic 700 0.63vw 'IBM Plex Sans',sans-serif",
      "transform": "skewX(-14deg)",
      "borderRadius": "0.1vw"
    }
  }, v.text("V/S"))) : null, React.createElement("span", {
    style: {
      "font": "600 0.83vw 'IBM Plex Mono',monospace",
      "color": c.c,
      "whiteSpace": "nowrap"
    }
  }, v.text(c.n))))))) : null, v.text("\n      "), v.vsNoHdr ? React.createElement(React.Fragment, null, v.locationSlot) : null, v.text("\n      "), React.createElement("div", {
    style: {
      "marginTop": "0.55vh",
      "fontSize": "0.78vw",
      "color": "#9ea7b4",
      "fontWeight": "600",
      "letterSpacing": "0.02vw",
      "whiteSpace": "nowrap"
    }
  }, v.text(v.rngHdr)), v.text("\n    ")), v.text("\n    "), React.createElement("div", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "justifyContent": "flex-end",
      "gap": "0.8vw",
      "flex": "0 0 30%",
      "minWidth": "fit-content"
    }
  }, v.text("\n      \n      "), React.createElement("div", {
    style: {
      "display": "flex",
      "gap": "0.8vw"
    }
  }, React.createElement("button", {
    "onClick": v.toggleDrawer,
    "title": "Vistas y ajustes",
    style: {
      "width": "2.8vw",
      "height": "6vh",
      "display": "flex",
      "alignItems": "center",
      "justifyContent": "center",
      "background": "transparent",
      "border": "0",
      "borderRadius": "0.8vw",
      "cursor": "pointer",
      "color": "#cfd5df"
    },
    className: "scapp-full-appbar-action"
  }, React.createElement("svg", {
    "width": "1.5vw",
    "height": "1.5vw",
    "viewBox": "0 0 24 24",
    "fill": "currentColor"
  }, React.createElement("path", {
    "d": "M19.4 13a7.5 7.5 0 0 0 0-2l2.1-1.6-2-3.5-2.5 1a7.6 7.6 0 0 0-1.7-1L15 3.3h-4l-.4 2.6a7.6 7.6 0 0 0-1.7 1l-2.5-1-2 3.5L6.6 11a7.5 7.5 0 0 0 0 2l-2.1 1.6 2 3.5 2.5-1c.5.4 1.1.7 1.7 1l.4 2.6h4l.4-2.6c.6-.3 1.2-.6 1.7-1l2.5 1 2-3.5L19.4 13ZM13 15.5a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7Z",
    "transform": "translate(-1 0)"
  }, null))), React.createElement("button", {
    "title": "Descargar datos",
    style: {
      "width": "2.8vw",
      "height": "6vh",
      "display": "flex",
      "alignItems": "center",
      "justifyContent": "center",
      "background": "transparent",
      "border": "0",
      "borderRadius": "0.8vw",
      "cursor": "pointer",
      "color": "#cfd5df"
    },
    className: "scapp-full-appbar-action",
    onClick: v.downloadData
  }, React.createElement("svg", {
    "width": "1.5vw",
    "height": "1.5vw",
    "viewBox": "0 0 24 24",
    "fill": "currentColor"
  }, React.createElement("path", {
    "d": "M11 3h2v9.2l3.3-3.3 1.4 1.4L12 16l-5.7-5.7 1.4-1.4L11 12.2V3Z"
  }, null), React.createElement("path", {
    "d": "M5 19h14v2H5z"
  }, null)))), v.text("\n      "), v.measurementSlot, v.text("\n      "), React.createElement("img", {
    "src": scappLogo,
    "alt": "SCAPP",
    "className": "img-logo-scapp",
    style: {
      "width": "7vw",
      "height": "auto",
      "display": "block"
    }
  }, null), v.text("\n    ")), v.text("\n  ")), v.text("\n  "), React.createElement("div", {
    style: {
      "flex": "1",
      "minHeight": "0",
      "display": "flex",
      "gap": "0"
    }
  }, v.text("\n  "), React.createElement("main", {
    style: {
      "position": "relative",
      "flex": "1",
      "minWidth": "0",
      "minHeight": "0",
      "display": "flex",
      "flexDirection": "column",
      "gap": "1.111111vh",
      "padding": "1.111111vh 1.851852vh 1.851852vh 1.851852vh"
    }
  }, v.text("\n  "), v.noData ? React.createElement(React.Fragment, null, React.createElement("div", {
    style: {
      "flex": "1",
      "display": "flex",
      "flexDirection": "column",
      "alignItems": "center",
      "justifyContent": "center",
      "gap": "1.111111vh",
      "textAlign": "center"
    }
  }, React.createElement("svg", {
    "width": "44",
    "height": "44",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "stroke": "#5a667a",
    "strokeWidth": "1.5",
    "strokeLinecap": "round"
  }, React.createElement("path", {
    "d": "M4 6h16v14H4zM4 10h16M8 3v4M16 3v4M9 14l6 4M15 14l-6 4"
  }, null)), React.createElement("span", {
    style: {
      "fontSize": "1.666667vh",
      "fontWeight": "600"
    }
  }, v.text(v.noDataT)), React.createElement("span", {
    style: {
      "fontSize": "1.203704vh",
      "color": "#8793a6"
    }
  }, v.text(v.noDataS)), React.createElement("div", {
    style: {
      "display": "flex",
      "gap": "0.925926vh"
    }
  }, React.createElement("button", {
    "onClick": v.openCal,
    style: {
      "border": "0.092593vh solid rgba(232,80,20,0.4)",
      "background": "transparent",
      "color": "#e4e9f0",
      "borderRadius": "0.740741vh",
      "padding": "0.648148vh 1.481481vh",
      "cursor": "pointer",
      "font": "600 1.203704vh 'IBM Plex Sans',sans-serif"
    }
  }, v.text("Cambiar rango")), React.createElement("button", {
    "onClick": v.goAll,
    style: {
      "border": "0",
      "background": "oklch(0.62 0.18 42)",
      "color": "#fff",
      "borderRadius": "0.740741vh",
      "padding": "0.648148vh 1.481481vh",
      "cursor": "pointer",
      "font": "600 1.203704vh 'IBM Plex Sans',sans-serif"
    }
  }, v.text("Ver todo con datos"))))) : null, v.text("\n  "), React.createElement(RangeSummary, {
    v
  }), v.text("\n\n  "), React.createElement(DashboardView, {
    v
  }), v.text("\n  "), React.createElement(CauseAnalysisView, {
    v
  }), v.text("\n  "), React.createElement(SimpleAnalyticsView, {
    v
  }), v.text("\n  "), React.createElement(VersusView, {
    v
  }), v.text("\n  "), React.createElement(FeederScoreView, {
    v
  }), v.text("\n  "), React.createElement(ComparisonView, {
    v
  }), v.text("\n  ")), v.text("\n  ")), v.text("\n  "), React.createElement(SettingsDrawer, {
    v
  }), v.text("\n  "), React.createElement(CalendarDialog, {
    v
  }), v.text("\n")), v.text("\n")), v.text("\n"));
}
